<template>
      <span>{{time}}</span>
</template>

<script>
   export default{
       data () {
           return {
               time : '',
               flag : false
           }

       },
       mounted () {
           let time = setInterval(()=>{
               if(this.flag == true){
                   clearInterval(time)
               }
               this.timeDown()
           },500)
       },
       props : {
           endTime : {
               type : Number
           }
       },
       methods : {
           timeDown () {
               
               const nowTime = new Date();
               let leftTime = parseInt((this.endTime - nowTime.getTime())/1000)
            //    let d = parseInt(leftTime/(24*60*60))
            //    let h = this.formate(parseInt(leftTime/(60*60)%24))
            //    let m = this.formate(parseInt(leftTime/60%60))
      
            
               let s = this.formate(parseInt(leftTime%60))
               if(leftTime <= 0){
                   this.flag = true
                   this.$emit('time-end')
                  
               }

               this.time = `${s}秒`
           },
           formate (time) {
               if(time>=10){
                   return time
               }else{
                   return `0${time}`
               }
           }
       }
   }
</script>



// WEBPACK FOOTER //
// src/components/widget/rainCounter.vue